import IconToolTip from "@/Components/Icon/IconToolTip";
import { useSetPosModal } from "@/shared/atoms/usePosModal";
import useIsMobileHook from "@/shared/hooks/useIsMobileHook";
import { useTranslation } from "react-i18next";

const LivePosButton = () => {
  const setIsPosOrderOpen = useSetPosModal();
  const isMobile = useIsMobileHook();
  const { t } = useTranslation("");

  return !isMobile ? (
    <div
      data-tour="live-orders.pos"
      onClick={() => setIsPosOrderOpen(true)}
      className="ml-auto flex flex-[0_1_auto]"
    >
      <IconToolTip
        variants="cashRegister"
        className="fill-dark"
        text={t("livePosOrder")}
      />
    </div>
  ) : null;
};

export default LivePosButton;
